import React, { useContext, useEffect, useState } from "react";
import Application from "../../../StateContext/Application.js";
import {
  Approved32,
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
  SendBack32,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import FundCreation from "../FundManage/FundCreation.js";
const FundInwardList = () => {
  const operation = useContext(Application);
  const { GetNewFundList, FundApproval, Usermenu } = operation;

  const [fund, setFund] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SelectedOptions, setSelectedOptions] = useState("Pending");
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  const [showEditForm, setShowEditForm] = useState(false);
  const [editFundData, setEditFundData] = useState(null);
  const [menuData, setMenuData] = useState(null);
  const [selectedBill, setSelectedBill] = useState(null);

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  console.log("currentbills", currentBills);
  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log(res);
      setMenuData(res.Data);
    };

    getMenu();
  }, []);
  const isMaker =
    menuData?.Department_Name === "State Maker" &&
    menuData?.Role === "State Maker";

  const isChecker =
    menuData?.Department_Name === "State Checker" &&
    menuData?.Role === "State Checker";
  console.log("menuData", menuData);

  useEffect(() => {
    console.log("Fund length:", fund.length);
    console.log("Fund data:", fund);
    FundList();
  }, []);
  useEffect(() => {
    FundList();
  }, []);

  // const FundList = async () => {
  //   try {
  //     let res = await GetNewFundList();
  //     console.log("res", res);
  //     setFilteredBills(res?.result || []);
  //     setFund(res?.result || []);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const FundList = async () => {
    try {
      let res = await GetNewFundList();
      console.log("API Response:", res);

      const data = res?.result || [];

      // Latest added record first
      const latestFirst = [...data].reverse();

      setFilteredBills(latestFirst);
      setFund(latestFirst);
      setCurrentPage(1);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id],
    );
    // setSelectedBill((prev) => (prev === id ? null : id));
  };
  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.FundID));
    } else {
      setSelectedBills([]);
    }
  };

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Fund selected for approval!");
      return;
    }
    console.log(selectedBills);
    setLoading(true);
    let shouldStart = window.confirm("Are you sure ???");
    if (shouldStart) {
      try {
        let response = await FundApproval(selectedBills, condition, remark);
        if (response.message) {
          alert(response.message);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
        if (response.error) {
          alert(response.error);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
      } catch (error) {
        console.error("Error approving Fund:", error);
        alert("An error occurred while approving Fund.");
        setRejectpanelhide(0);
        setLoading(false);
        setRemark("");
        window.location.reload();
      }
    } else {
      alert(`Fund ${condition} Operation Cancelled !!!`);
      setRemark("");
      setRejectpanelhide(0);
      window.location.reload();
    }
    setLoading(false); // Stop loader
  };

  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No Fund Selected !!!");
    }
  };

  const getFundInwardPageNumbers = () => {
    const maxVisiblePages = 5;

    // 5 ya usse kam pages
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

  return (
    <>
      {!showEditForm ? (
        <>
          <div
            className="col-12"
             style={{
              backgroundColor: "#ffffff",
              height: "90vh",
              overflowX: "hidden",
              overflowY: "scroll",
              //29/10
               padding: "15px 20px",       
    boxSizing: "border-box"
            }}
          >
             <div
  style={{
    background: "#EEF2F7",
    border: "1px solid #dfe5ee",
    borderRadius: "10px",
    padding: "15px 20px 20px",
    width: "100%",
    boxSizing: "border-box",
  }}
>
              <div
                 style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "15px",
  }}
              >
                <h5
                  className="my-auto fw-bold"
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    color: "#111",
                  }}
                ><img
    src="/Fund-Inward-List-32.png"
    alt="img"
   style={{height:"28px", width:"28px", marginLeft:"10px"}}
  />
                  <span className="my-auto">Fund Inward List</span>
                </h5>
                <div
                  style={{
                    position: "relative",
                    width: "250px",
                    marginRight: "10px",
                  }}
                >
                  <img
                    src="/Search32.png"
                    alt="Search Icon"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                      width: "16px",
                      height: "16px",
                      opacity: 0.6,
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search Here"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    style={{
                      width: "100%",
                      height: "34px",
                      padding: "6px 10px 6px 32px",
                      border: "1px solid #d0d7df",
                      borderRadius: "6px",
                      backgroundColor: "#ffffff",
                      fontSize: "11px",
                      color: "#333",
                      outline: "none",
                      boxSizing: "border-box",
                    }}
                  />
                </div>
              </div>
              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      border: "6px solid #f3f3f3",
                      borderTop: "6px solid #007bff",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  <style>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
                </div>
              )}
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "#ffffff",
                  padding: "20px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                  borderRadius: "12px",
                  width: "100%",
                  maxWidth: "calc(100% - 40px)",
                  boxSizing: "border-box",
                  overflow: "hidden",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  style={{
                    background: "#ffffff",
                    overflowX: "auto",
                    border: "1px solid #d9e2f0",
                    borderRadius: "6px",
                  }}
                >
                  {SelectedOptions === "Pending" && (
                    <table
                      className="m-0 p-0"
                      style={{
                        width: "100%",
                        minWidth: "1000px",
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        overflow: "hidden",
                        borderRadius: "6px",
                        tableLayout: "auto",

                        borderSpacing: 0,
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            //28/10
                            color: "white",
                            backgroundColor: "#2D79D9",
                            border: "none",
                            height: "38px",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          <th style={{ minWidth: "50px", padding: "8px" }}>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                currentBills.length > 0 &&
                                currentBills.every((bill) =>
                                  selectedBills.includes(bill.FundID),
                                )
                              }
                              className="my-auto"
                              style={{ height: "1rem", width: "1rem" }}
                            />
                          </th>
                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            Sr No
                          </th>

                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            Year
                          </th>
                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            GR Number
                          </th>

                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            Letter Number
                          </th>
                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            Date
                          </th>
                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            UTR Number
                          </th>
                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            Bank UTR Date
                          </th>
                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            Fund Amount
                          </th>
                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            Upload Copy
                          </th>
                          {isMaker && (
                            <th
                              style={{
                                padding: "8px 10px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                                verticalAlign: "middle",
                              }}
                            >
                              Remark
                            </th>
                          )}
                          {isMaker && (
                          <th
                            style={{
                              padding: "8px 10px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            Action
                          </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {currentBills.length <= 0 ? (
                          <tr>
                            <td
                              colSpan="12"
                              style={{
                                textAlign: "center",
                                padding: "15px 10px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              {" "}
                              No data available
                            </td>
                          </tr>
                        ) : (
                          currentBills?.map((fund, index) => {
                            const bgColor =
                               index % 2 === 0 ? "#E5F4FB" : "#CEE4F1";
                            return (
                              <tr
                                style={{
                                  backgroundColor: bgColor,
                                  fontSize: "12px",
                                  fontWeight: "500",
                                }}
                                key={index}
                              >
                                <td style={{ textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    className="my-auto"
                                    style={{ height: "1rem", width: "1rem" }}
                                    checked={selectedBills.includes(
                                      fund.FundID,
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(fund.FundID)
                                    }
                                  />
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  {indexOfFirstBill + index + 1}
                                </td>

                                <td style={{ padding: "10px" }}>{fund.Year}</td>
                                <td style={{ padding: "10px" }}>
                                  {fund.GRNumber}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {fund.LetterNumber}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {fund.Date?.split("T")[0].replace(" ")}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {fund.UTRNumber}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {fund.BankUTRDate?.split("T")[0].replace(" ")}
                                </td>
                                <td style={{ padding: "10px" }}>
                                  {/* {fund.FundAmount} */}₹
                                  {Number(fund.FundAmount || 0).toLocaleString(
                                    "en-IN",
                                  )}
                                </td>
                                <td  style={{ padding: "8px", minWidth: "160px", width: "160px", maxWidth: "160px", whiteSpace: "nowrap", textAlign: "center",}}>
                                  <a href={`${apiurl}/FundDocs/${fund.UploadCopy}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    title={fund.UploadCopy}
                                    style={{display: "flex",alignItems: "center",  justifyContent: "center", gap: "5px", width: "100%", overflow: "hidden",textDecoration: "none", color: "#0d6efd", }}>
                                    {" "}
                                   UploadCopy
                                  </a>
                                </td>
                                {isMaker && (
                                  <td style={{ padding: "10px" }}>
                                    {fund.Remark}
                                  </td>
                                )}

                                {isMaker && (
                                  <td
                                    style={{
                                      padding: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                
                                        <button
        onClick={() => {
            setEditFundData(fund);
            setShowEditForm(true);
        }}
        disabled={!selectedBills.includes(fund.FundID) || selectedBills.length !== 1}
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            marginLeft: "30px",
            padding: "8px 10px",
            fontWeight: "600",
            background: (!selectedBills.includes(fund.FundID) || selectedBills.length !== 1) ? "#6b6767" : "#0D6EFD",
            color: (!selectedBills.includes(fund.FundID) || selectedBills.length !== 1) ? "#888" : "white",
            border: (!selectedBills.includes(fund.FundID) || selectedBills.length !== 1) ? "1px solid #aaa1a1" : "1px solid #0D6EFD",
            borderRadius: "8px",
            cursor: (!selectedBills.includes(fund.FundID) || selectedBills.length !== 1) ? "not-allowed" : "pointer",
            opacity: (!selectedBills.includes(fund.FundID) || selectedBills.length !== 1) ? 0.65 : 1,
            boxShadow: (!selectedBills.includes(fund.FundID) || selectedBills.length !== 1) ? "none" : "0 2px 4px rgba(0,0,0,0.15)",
        }}
    >
        <img src={Edit32WHITE} style={{ width: "16px" }} />
        <span style={{ color: "white", fontSize: "12px" }}>Edit</span>
    </button>
 
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
                <div className="col-12 mt-3">
                  <div className="row">
                    <div
                      className="col-6 text-start"
                      style={{ display: "flex", justifyContent: "left" }}
                    >
                      <button
                        onClick={() => approveorrejectSelected("Approved")}
                        disabled={selectedBills.length <= 0 ? true : loading}
                        className="ms-0"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.3rem",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          backgroundColor:
                            selectedBills.length <= 0 ? "#f3eeee" : "#39B54A",

                          color:
                            selectedBills.length > 0 ? "#ffffff" : "#01B574",
                          border: "1px solid #39B54A",

                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                        <img
                          src={Approved32}
                          alt="Approve"
                          style={{
                            width: "18px",
                            height: "18px",
                            flexShrink: 0,
                          }}
                        />{" "}
                        {loading ? "Processing..." : "Approve Selected"}
                      </button>
                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(2)}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            backgroundColor:
                              selectedBills.length <= 0 ? "#f3eeee" : "#C1272D",

                            color: selectedBills.length > 0 ? "#ffffff" : "red",
                            border: "1px solid #ff6b81",
                            borderRadius: "8px",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                            src={DeleteRed32}
                            alt="Reject"
                            style={{
                              width: "18px",
                              height: "18px",
                              filter:
                                selectedBills.length > 0
                                  ? "brightness(0) invert(1)"
                                  : "none",
                              flexShrink: 0,
                            }}
                          />{" "}
                          {loading ? "Processing..." : "Reject Selected"}
                        </button>
                      )}
                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(3)}
                          disabled={selectedBills.length <= 0 || loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            backgroundColor:
                              selectedBills.length <= 0 ? "#f3eeee" : "blue",
                            border: "1px solid blue",
                            color: selectedBills.length > 0 ? "white" : "blue",
                            whiteSpace: "nowrap",
                            borderRadius: "8px",

                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0 || loading
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          <img
                            src={SendBack32}
                            alt="Send Back"
                            style={{
                              width: "18px",
                              height: "18px",
                              flexShrink: 0,
                              filter:
                                selectedBills.length > 0
                                  ? "brightness(0) invert(1)"
                                  : "invert(28%) sepia(99%) saturate(7486%) hue-rotate(230deg) brightness(89%) contrast(128%)",
                            }}
                          />
                          {loading ? "Processing..." : "Send Back Selected"}
                        </button>
                      )}
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: "15px",
                        padding: "10px 5px",
                        boxSizing: "border-box",
                      }}
                    >
                      {/* Showing Entries */}
                      <div
                        style={{
                          fontSize: "13px",
                          color: "#333",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Showing{" "}
                        {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1}{" "}
                        to{" "}
                        {Math.min(indexOfLastBill, filteredBills?.length || 0)}{" "}
                        of {filteredBills?.length || 0} entries
                      </div>

                      {/* Pagination Right Side */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "18px",
                        }}
                      >
                        {/* Previous */}
                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                          style={{
                            border: "none",
                            background: "transparent",
                            color: "#2ea4e7",
                            cursor:
                              currentPage === 1 ? "not-allowed" : "pointer",
                            fontSize: "12px",
                            padding: 0,
                            opacity: currentPage === 1 ? 0.5 : 1,
                          }}
                        >
                          ‹ Previous
                        </button>

                        {/* Page Numbers */}
                        {getFundInwardPageNumbers().map((pageNumber, index) => {
                          if (pageNumber === "...") {
                            return (
                              <span
                                key={`ellipsis-${index}`}
                                style={{
                                  fontSize: "13px",
                                  color: "#444",
                                }}
                              >
                                ...
                              </span>
                            );
                          }

                          return (
                            <button
                              key={pageNumber}
                              onClick={() => setCurrentPage(pageNumber)}
                              style={{
                                border: "none",
                                background: "transparent",
                                padding: 0,
                                color:
                                  currentPage === pageNumber
                                    ? "#2ea4e7"
                                    : "#444",
                                cursor: "pointer",
                                fontSize: "13px",
                                fontWeight:
                                  currentPage === pageNumber ? "600" : "400",
                                textDecoration:
                                  currentPage === pageNumber
                                    ? "underline"
                                    : "none",
                              }}
                            >
                              {pageNumber}
                            </button>
                          );
                        })}

                        {/* Next */}
                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages),
                            )
                          }
                          disabled={
                            currentPage === totalPages || totalPages === 0
                          }
                          style={{
                            border: "none",
                            background: "transparent",
                            color: "#2ea4e7",
                            cursor:
                              currentPage === totalPages || totalPages === 0
                                ? "not-allowed"
                                : "pointer",
                            fontSize: "12px",
                            padding: 0,
                            opacity:
                              currentPage === totalPages || totalPages === 0
                                ? 0.5
                                : 1,
                          }}
                        >
                          Next ›
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {rejectPanelhide === 2 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          Remark <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder="Enter Remark"
                          onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    {/* <div className="col-3"></div> */}
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "5rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("Rejected")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Reject
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {rejectPanelhide === 3 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          Remark <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder="Enter Remark"
                          onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    {/* <div className="col-3"></div> */}
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "8rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("SendBack")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Send
                          Back
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <FundCreation
          isEdit={true}
          fundData={editFundData}
          onSuccess={() => {
            setShowEditForm(false);
            FundList();
            setSelectedBills([]);
          }}
          onCancel={() => {
            setShowEditForm(false);
          }}
        />
      )}
    </>
  );
};

export default FundInwardList;
